import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { METRIC_SLUGS, COLORS, METRICS } from './regstatsmetricsConfig';
import { RegStatsGraph } from './RegStatsGraph.jsx';
import { AVERAGE_METRICS, RUBLE_METRIC } from './regstatsmetricsConfig.js';
import s from "../../admin_styles/RegStats.module.css";
import Loader from '../Loader.jsx';

const RegStats = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedMetric, setSelectedMetric] = useState(''); // пустая метрика — сервер сам решает
  const [metricData, setMetricData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchMetric = async (metricKey, dateFrom, dateTo) => {
    try {
      const response = await fetch('/api/admin/regstatsgraph', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          metric: metricKey,
          date_from: dateFrom,
          date_to: dateTo,
        }),
      });

      const result = await response.json();

      if (!response.ok || result.error) {
        throw new Error(result.error || 'Ошибка получения данных');
      }

      return result;
    } catch (error) {
      console.error('⚠️ Ошибка при загрузке метрики:', error.message);
      return {
        data: [],
      };
    }
  };

  function formatDateLocal(d) {
  return (
    d.getFullYear() +
    '-' +
    String(d.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(d.getDate()).padStart(2, '0')
  );
}

  const fetchData = async () => {
    if ( !dateRange[0] || !dateRange[1]) return;
    setLoading(true);

  const from = formatDateLocal(dateRange[0]);
  const to   = formatDateLocal(dateRange[1]);

    const data = await fetchMetric(selectedMetric, from, to);
    setMetricData(data);

    setLoading(false);
  };

  // Автоматически подставить последние 30 дней при первой загрузке
  useEffect(() => {
    const now = new Date();
    const start = new Date();
    start.setDate(now.getDate() - 30);
    setDateRange([start, now]);
    setSelectedMetric(''); // пусто = взять сохранённую с сервера
  }, []);

  // Перезапрос при изменении диапазона или метрики
  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      fetchData();
    }
  }, [selectedMetric, dateRange]);



  return (
    <div className={s.wrapper}>
      <div className={s.filters}>
        <DatePicker
          selectsRange
          startDate={dateRange[0]}
          endDate={dateRange[1]}
          onChange={(update) => setDateRange(update)}
          dateFormat="dd.MM.yyyy"
          placeholderText="Выберите период"
          className={s.datepicker}
        />

        <select
          value={selectedMetric}
          onChange={(e) => setSelectedMetric(e.target.value)}
          className={s.metricSelect}
        >
          {/* Показывать сохранённую метрику, только если сервер ещё её не вернул */}
          {selectedMetric === '' && !metricData?.metric && (
            <option value="">Выберите метрику</option>
          )}
          {Object.entries(METRICS).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
          <Loader />
      ) : (
        metricData && (
          <RegStatsGraph
            label={METRICS[selectedMetric] || (METRICS[metricData?.metric] || 'Нет данных.')}
            data={metricData.data}
            color={COLORS[selectedMetric] || COLORS[metricData?.metric]}
            average={AVERAGE_METRICS[selectedMetric] || AVERAGE_METRICS[metricData?.metric]}
            ruble={RUBLE_METRIC[selectedMetric] || RUBLE_METRIC[metricData?.metric]}
          />
        )
      )}
    </div>
  );
};

export default RegStats;

